import type * as React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { Skeleton } from '@/components/ui/skeleton';

import { useAuth } from './useAuth';

interface RequireAdminProps {
  children: React.ReactNode;
  redirectTo?: string;
}

export function RequireAdmin({
  children,
  redirectTo = '/admin/login',
}: RequireAdminProps): React.JSX.Element {
  const { status } = useAuth();
  const location = useLocation();

  if (status === 'loading') {
    return (
      <div className="space-y-3 p-6" data-testid="require-admin-skeleton">
        <Skeleton className="h-6 w-40" />
        <Skeleton className="h-32 w-full" />
      </div>
    );
  }
  if (status === 'unauthenticated') {
    return (
      <Navigate to={redirectTo} state={{ from: location.pathname + location.search }} replace />
    );
  }
  return <>{children}</>;
}
